export default function CsNetworkAttacks() {
  return (
    <h2>Cs Network Attacks</h2>
  );
}
